import React from 'react';
import { Modal } from 'framework/ui/ui-builder';
import { Grid2 as Grid, Typography } from '@mui/material';
import { LinkField } from 'framework/ui/field';

interface ExternalReportModalViewProps {
  data: any;
  externalModalViewOpen: boolean;
  setExternalModalViewOpen: (open: boolean) => void;
}

const ExternalReportModalView: React.FC<ExternalReportModalViewProps> = ({
  data,
  externalModalViewOpen,
  setExternalModalViewOpen,
}) => {
  return (
    <Modal
      title="Customer report"
      isOpen={externalModalViewOpen}
      onToggle={() => setExternalModalViewOpen(false)}
      hasCloseIcon
    >
      <Grid container spacing={2} size={12}>
        <Grid size={6}>
          <Typography>Period from: {data?.periodStart}</Typography>
        </Grid>
        <Grid size={6}>
          <Typography>Period to: {data?.periodEnd}</Typography>
        </Grid>
        <Grid size={12}>
          <LinkField value={data?.externalReportLink} label="Report link" />
        </Grid>
      </Grid>
    </Modal>
  );
};

export default ExternalReportModalView;
